<div v-if="errors.length > 0">
  <div class="px-5 py-3 bg-red-200 text-red-800 rounded">
    <ul v-for="(error, i) in errors" class="list-disc ml-5">
      <li>{{ error }}</li>
    </ul>
  </div>
</div>
